import React, { Component } from 'react'

export default class AboutUs extends Component {
    render() {
        return (
            <div>
                <iframe src="./staticPage/aboutus.html" style={{width:"100%", height:"100vh"}} className="iframe-aboutus"></iframe>
            </div>
        )
    }
}
